import { ExamGetForm } from "../exam/ExamListForm";
import Model from "@/lib/model/model";

export default class CandidateRepeatCreateForm extends ExamGetForm {
  candidateId = 0;
  sendMessage: any = 0;
}
